<template>
  <div class="modal-cover" @click="onCloseMoreModal">
    <div class="more-modal" @click.stop>
      <div class="more-item attendance" @click="onToggleAttendanceModal">{{ $t('camstudy.moreModal.attendance') }}</div>
      <div class="more-item stopwatch-setting" @click="onToggleStopWatchSettingModal">{{ $t('camstudy.moreModal.stopwatch') }}</div>
      <div class="more-item study-setting" v-if="hasEmceeRole()" @click="onToggleRoomSettingModal">{{ $t('camstudy.moreModal.studySetting') }}</div>
      <div class="more-item white-noise" @click="onToggleWhiteNoiseModal">{{ $t('camstudy.moreModal.whiteNoise') }}</div>
      <div class="more-item block" v-if="hasEmceeRole()" @click="onToggleBlockMemberModal">{{ $t('camstudy.moreModal.blockMember') }}</div>
      <div class="more-item chat" @click="onToggleChatModal">{{ $t('camstudy.moreModal.chat') }}<span v-if="isExistsUnReadChat" class="unread-chat">{{unReadChatLength}}</span></div>
      <div class="more-item my-setting" @click="onToggleMySettingModal">{{ $t('camstudy.moreModal.setting') }}</div>
    </div>
  </div>
</template>

<script>
import CamstudyAttendanceModal from "@/components/Room/Camstudy/control/Attendance.vue";
import CamstudyRoomSettingModal from "@/components/Room/Camstudy/control/RoomSetting.vue";
import CamstudyWhiteNoiseModal from "@/components/Room/Camstudy/control/WhiteNoise.vue";
import CamstudyBlockMemberModal from "@/components/Room/Camstudy/control/BlockMember.vue";
import CamstudyChatModal from "@/components/Room/Camstudy/control/Chat.vue";
import CamstudyMySettingModal from "@/components/Room/Camstudy/control/MySetting.vue"
import {mapActions, mapGetters} from "vuex";
import CamstudyStopWatchSettingModal from "@/components/Room/Camstudy/control/StopWatchSettingModal.vue";

export default {
  name: 'ControlMoreModal',
  mounted(){
    this.onToggleChatModal()
  },
  computed: {
    ...mapGetters('user', ['hasEmceeRole']),
    ...mapGetters('chat', [
        'unReadChatLength',
        'isExistsUnReadChat'
    ]),
    ...mapGetters('room', ['isPremiumRoom'])
  },
  methods: {
    ...mapActions('chat', [
        'resetUnReadChat'
    ]),
    onToggleAttendanceModal(){
      this.$modal(CamstudyAttendanceModal, {once: true}, this.onCloseMoreModal)
    },
    onToggleRoomSettingModal(){
      this.$modal(CamstudyRoomSettingModal, {once: true}, this.onCloseMoreModal)
    },
    onToggleWhiteNoiseModal(){
      this.$modal(CamstudyWhiteNoiseModal, {once: true}, this.onCloseMoreModal)
    },
    onToggleBlockMemberModal(){
      this.$modal(CamstudyBlockMemberModal, {once: true}, this.onCloseMoreModal)
    },
    onToggleChatModal(){
      this.$modal(CamstudyChatModal, {once: true, exist: true}, () => {
        this.onCloseMoreModal();
        this.resetUnReadChat();
      })
    },
    onToggleMySettingModal(){
      this.$modal(CamstudyMySettingModal, {once: true}, this.onCloseMoreModal)
    },
    onCloseMoreModal(){
      this.$emit('onCloseMoreModal')
    },
    onToggleStopWatchSettingModal(){
      this.$modal(CamstudyStopWatchSettingModal, {once: true, data: {fade: false}}, this.onCloseMoreModal)
    },
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .modal-cover{
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait){
      left: 0;
      right: 0;
      bottom: 0;
    }
    @media(orientation: landscape){
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
    }
  }
}
html:not([grm-device-mobile]){
  .modal-cover{
    left: 0;
    right: 0;
    bottom: 80px;
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  z-index: 2;
}
.more-modal{
  &::-webkit-scrollbar{
    display: none;
  }
  position: absolute;
  border-radius: 12px;
  background: #313131;
  padding: 12px 0;
  width: calc(100% - 16px);
  z-index: 100;

  @media(orientation: portrait) {
    bottom: 72px;
    left: 8px;
  }
  @media(orientation: landscape){
    bottom: 8px;
    max-height: calc(100dvh - 98px - 16px);
    width: 360px;
    left: 50%;
    overflow-y: scroll;
    transform: translateX(-50%);
  }

  .more-item{
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 20px 0 60px;
    font-size: 14px;
    color: white;

    &.attendance{
      background: url('~@/assets/images/camstudy/ico_partcipant_white.svg') no-repeat center left 18px;
    }
    &.stopwatch-setting{
      background: url('~@/assets/images/camstudy/ico_stopwatch_setting_white.svg') no-repeat center left 18px;
    }
    &.study-setting{
      background: url('~@/assets/images/camstudy/ico_study_setting_white.svg') no-repeat center left 18px;
    }
    &.white-noise{
      background: url('~@/assets/images/camstudy/ico_white_noise_white.svg') no-repeat center left 18px;
    }
    &.block{
      background: url('~@/assets/images/camstudy/ico_block_member_white.svg') no-repeat center left 18px;
    }
    &.chat{
      background: url('~@/assets/images/camstudy/control_chat.svg') no-repeat center left -2px;
      .unread-chat{
        padding: 4px 6px;
        min-width: 18px;
        height: 18px;
        border-radius: 30px;
        background: #016FF2;

        color: #FFF;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
        line-height: 100%;
        margin-left: 12px;
      }
    }
    &.my-setting{
      background: url('~@/assets/images/camstudy/ico_my_setting_white.svg') no-repeat center left 18px;
    }
  }
}
</style>